module.exports = __webpack_public_path__ + "img/conny-f-stage2-blink.05314769.png";